import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  obtenerPaciente,
  listarSesiones,
  eliminarSesion,
  listarPagosPaciente,
  me,
  guardarComentarioSesion,
  actualizarCamposClinicosPaciente,
} from "../api";
import CommentsThread from "../components/CommentsThread";
import CitasFuturasTable from "../components/PacienteViewComponents/CitasFuturasTable";
import CitasPasadasTable from "../components/PacienteViewComponents/CitasPasadasTable";
import PagosTable from "../components/PacienteViewComponents/PagosTable";
import ContratoTab from "../components/ContratoTab";
import UploadTab from "../components/UploadTab";
import ConsentimientoTab from "../components/ConsentimientoTab";
import "./PacienteView.css";

export default function PacienteView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [paciente, setPaciente] = useState(null);
  const [citasFuturas, setCitasFuturas] = useState([]);
  const [citasPasadas, setCitasPasadas] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedSesion, setSelectedSesion] = useState(null);
  const [nuevoComentario, setNuevoComentario] = useState("");
  const [tab, setTab] = useState("info");

  const [dateFilterCitas, setDateFilterCitas] = useState("");
  const [dateFilterPasadas, setDateFilterPasadas] = useState("");
  const [dateFilterPagos, setDateFilterPagos] = useState("");

  // estados de guardado y edición
  const [savingEmailTutorCole, setSavingEmailTutorCole] = useState(false);
  const [savingObjetivos, setSavingObjetivos] = useState(false);
  const [editEmailTutorCole, setEditEmailTutorCole] = useState(false);
  const [editObjetivos, setEditObjetivos] = useState(false);

  // ---------- Helpers de formato SOLO para mostrar ----------
  const formatDateLabel = (dateLike) => {
    const d = new Date(dateLike);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("es-ES");
  };

  const formatTimeLabel = (dateLike) => {
    const d = new Date(dateLike);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  };

  const formatBirthdate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("es-ES");
  };

  const calculateAge = (dateStr) => {
    if (!dateStr) return null;
    const birth = new Date(dateStr);
    if (Number.isNaN(birth.getTime())) return null;

    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age >= 0 ? age : null;
  };

  useEffect(() => {
    me()
      .then((r) => {
        console.log("[PacienteView] Usuario actual:", r.user);
        setUser(r.user);
      })
      .catch((e) => {
        console.error("[PacienteView] Error en me():", e);
      });
  }, []);
  const isAdmin = user?.role === "admin";

  const loadData = useCallback(async () => {
    if (!id) return;
    try {
      setLoading(true);
      console.log("[PacienteView] Cargando paciente id:", id);

      const [p, ses] = await Promise.all([
        obtenerPaciente(id),
        listarSesiones({ patient_id: id }),
      ]);

      console.log("[PacienteView] obtenerPaciente:", p);

      const hoy = new Date();
      const todas = ses.items || [];

      const futuras = todas
        .filter((c) => new Date(c.start_datetime) >= hoy)
        .sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime));

      const pasadas = todas
        .filter((c) => new Date(c.start_datetime) < hoy)
        .sort((a, b) => new Date(b.start_datetime) - new Date(a.start_datetime));

      const fechaNacimientoRaw = p.fechaNacimiento || p.fecha_nacimiento;

      const pacienteConFechaFormateada = {
        ...p,
        fechaNacimientoLabel: formatBirthdate(fechaNacimientoRaw),
        edad: calculateAge(fechaNacimientoRaw),
      };

      setPaciente(pacienteConFechaFormateada);
      setCitasFuturas(futuras);
      setCitasPasadas(pasadas);

      // detectar si ya hay datos para decidir modo edición o solo lectura
      const hasEmailCole =
        !!(
          pacienteConFechaFormateada.tutor_email_cole ||
          (pacienteConFechaFormateada.tutor &&
            (pacienteConFechaFormateada.tutor.email_cole ||
              pacienteConFechaFormateada.tutor.email_tutor_cole))
        );

      const hasObjetivos = !!pacienteConFechaFormateada.objetivos;

      setEditEmailTutorCole(!hasEmailCole); // si no hay email -> editar
      setEditObjetivos(!hasObjetivos);      // si no hay objetivos -> editar
    } catch (e) {
      console.error("[PacienteView] Error al cargar paciente:", e);
      setError(e.message || "Error al cargar paciente");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

useEffect(() => {
  if (!isAdmin || !id) return;

  const params = dateFilterPagos ? { date: dateFilterPagos } : {};
  listarPagosPaciente(id, params)
    .then((r) => {
      console.log("[PacienteView] listarPagosPaciente respuesta:", r);
      if (Array.isArray(r)) setPagos(r);
      else if (Array.isArray(r.items)) setPagos(r.items);
      else setPagos([]);
    })
    .catch((e) => console.error("Error al cargar pagos:", e));
}, [id, dateFilterPagos, isAdmin]);


  const handleDeleteCita = async (citaId) => {
    if (!window.confirm("¿Seguro que deseas eliminar esta cita?")) return;
    try {
      await eliminarSesion(citaId);
      setCitasFuturas((prev) => prev.filter((c) => c.id !== citaId));
    } catch (e) {
      alert("Error al eliminar cita: " + e.message);
    }
  };

  const toggleSesionDetalle = (sesion) => {
    setSelectedSesion(sesion);
    setNuevoComentario("");
  };

  const handleAgregarComentario = async (id) => {
    if (!nuevoComentario.trim()) return;
    try {
      const res = await guardarComentarioSesion(id, nuevoComentario);
      console.log("[PacienteView] guardarComentarioSesion:", res);
      if (!res.ok) throw new Error(res.msg || "Error al guardar comentario");
      alert("✅ Comentario guardado correctamente.");
      setNuevoComentario("");
      await loadData();
    } catch (e) {
      console.error(e);
      alert("Error al guardar comentario: " + e.message);
    }
  };

  // ========= helpers para guardar SOLO campos clínicos =========
  const saveEmailTutorCole = async () => {
    if (!paciente?.id) {
      console.warn("[PacienteView] No hay paciente.id al guardar email tutor cole");
      return;
    }
    try {
      setSavingEmailTutorCole(true);
      console.log("[PacienteView] Guardando email tutor cole...", {
        id: paciente.id,
        tutor_email_cole: paciente.tutor_email_cole || "",
      });

      const resp = await actualizarCamposClinicosPaciente(paciente.id, {
        tutor_email_cole: paciente.tutor_email_cole || "",
      });

      console.log("[PacienteView] Respuesta actualizarCamposClinicosPaciente (email):", resp);

      if (resp && resp.patient) {
        setPaciente((prev) => ({
          ...prev,
          tutor_email_cole: resp.patient.tutor_email_cole,
          tutor: {
            ...(prev.tutor || {}),
            email_cole: resp.patient.tutor_email_cole,
          },
        }));
      }
      setEditEmailTutorCole(false); // -> pasa a modo texto + lápiz
      alert("Email tutor cole guardado");
    } catch (e) {
      console.error("[PacienteView] Error al actualizar email tutor cole:", e);
      alert("Error al guardar email tutor cole: " + (e.message || e));
    } finally {
      setSavingEmailTutorCole(false);
    }
  };

  const saveObjetivos = async () => {
    if (!paciente?.id) {
      console.warn("[PacienteView] No hay paciente.id al guardar objetivos");
      return;
    }
    try {
      setSavingObjetivos(true);
      console.log("[PacienteView] Guardando objetivos...", {
        id: paciente.id,
        objetivos: paciente.objetivos || "",
      });

      const resp = await actualizarCamposClinicosPaciente(paciente.id, {
        objetivos: paciente.objetivos || "",
      });

      console.log("[PacienteView] Respuesta actualizarCamposClinicosPaciente (objetivos):", resp);

      if (resp && resp.patient) {
        setPaciente((prev) => ({
          ...prev,
          objetivos: resp.patient.objetivos,
        }));
      }
      setEditObjetivos(false); // -> texto + lápiz
      alert("Objetivos guardados");
    } catch (e) {
      console.error("[PacienteView] Error al actualizar objetivos:", e);
      alert("Error al guardar objetivos: " + (e.message || e));
    } finally {
      setSavingObjetivos(false);
    }
  };
  // =====================================================================

  if (loading) return <div style={{ padding: "1rem" }}>Cargando…</div>;
  if (error) return <div style={{ padding: "1rem", color: "red" }}>{error}</div>;
  if (!paciente) return null;

  const tutor = paciente.tutor || {};

  const emailTutorColeValue =
    paciente.tutor_email_cole ||
    tutor.email_cole ||
    tutor.email_tutor_cole ||
    "";

  return (
    <div className="pv-wrap">
      <button className="pv-back" onClick={() => navigate(-1)}>
        ← Volver
      </button>

      <h2>{paciente.nombre}</h2>

      {/* ====== BOTONES DE PESTAÑA ====== */}
      <div className="tab-buttons" style={{ marginBottom: "1rem" }}>
        <button className={tab === "info" ? "active" : ""} onClick={() => setTab("info")}>
          🧍 Información
        </button>
        <button className={tab === "contrato" ? "active" : ""} onClick={() => setTab("contrato")}>
          🧾 Contrato
        </button>
        <button
          className={tab === "consentimiento" ? "active" : ""}
          onClick={() => setTab("consentimiento")}
        >
          🧠 Consentimiento menores
        </button>
        <button className={tab === "otros" ? "active" : ""} onClick={() => setTab("otros")}>
          📎 Otros documentos
        </button>
      </div>

      {/* ====== CONTENIDO DE PESTAÑAS ====== */}
      {tab === "info" && (
        <>
          <div className="pv-grid">
            <div>
              <strong>Fecha de nacimiento:</strong>{" "}
              {paciente.fechaNacimientoLabel || "—"}
            </div>
            <div>
              <strong>Edad:</strong>{" "}
              {typeof paciente.edad === "number" ? `${paciente.edad} años` : "—"}
            </div>
            <div>
              <strong>Sexo:</strong> {paciente.sexo || "—"}
            </div>
            <div>
              <strong>Colegio:</strong> {paciente.colegio || "—"}
            </div>
            <div>
              <strong>Dirección:</strong> {paciente.direccion || "—"}
            </div>
            <div>
              <strong>Teléfono:</strong> {paciente.telefono || "—"}
            </div>
            <div>
              <strong>Servicios:</strong>{" "}
              {paciente.servicios?.join(", ") || "—"}
            </div>
          </div>

          <div className="pv-section">
            <h3>Datos del tutor legal</h3>
            <p>
              <strong>Nombre:</strong> {tutor.nombre || "—"}
            </p>
            <p>
              <strong>DNI:</strong> {tutor.dni || "—"}
            </p>
            <p>
              <strong>Teléfono:</strong> {tutor.telefono || "—"}
            </p>
            <p>
              <strong>Email:</strong> {tutor.email || "—"}
            </p>

            {/* EMAIL TUTOR COLE */}
            <p>
              <strong>Email tutor cole:</strong>{" "}
              {editEmailTutorCole ? (
                <>
                  <input
                    type="email"
                    className="pv-inline-input"
                    value={emailTutorColeValue}
                    onChange={(e) =>
                      setPaciente((prev) => ({
                        ...prev,
                        tutor_email_cole: e.target.value,
                        tutor: {
                          ...(prev.tutor || {}),
                          email_cole: e.target.value,
                        },
                      }))
                    }
                    placeholder="Email del tutor del cole"
                  />{" "}
                  <button
                    type="button"
                    className="pv-btn-small"
                    onClick={saveEmailTutorCole}
                    disabled={savingEmailTutorCole}
                  >
                    {savingEmailTutorCole ? "Guardando..." : "Guardar"}
                  </button>
                </>
              ) : (
                <>
                  <span>{emailTutorColeValue}</span>{" "}
                  <button
                    type="button"
                    className="pv-btn-small"
                    onClick={() => setEditEmailTutorCole(true)}
                  >
                    ✏️ Editar
                  </button>
                </>
              )}
            </p>

            <p>
              <strong>Emergencia:</strong> {tutor.emergencia || "—"}
            </p>
          </div>

          <div className="pv-section">
            <h3>Observaciones</h3>
            <p>{paciente.observaciones || "—"}</p>
          </div>

          {/* OBJETIVOS */}
          <div className="pv-section">
            <h3>Objetivos</h3>
            {editObjetivos ? (
              <>
                <textarea
                  className="pv-textarea"
                  value={paciente.objetivos || ""}
                  onChange={(e) =>
                    setPaciente((prev) => ({
                      ...prev,
                      objetivos: e.target.value,
                    }))
                  }
                  placeholder="Objetivos de intervención..."
                  rows={4}
                />
                <div style={{ marginTop: "0.5rem" }}>
                  <button
                    type="button"
                    className="pv-btn-small"
                    onClick={saveObjetivos}
                    disabled={savingObjetivos}
                  >
                    {savingObjetivos ? "Guardando..." : "Guardar"}
                  </button>
                </div>
              </>
            ) : (
              <>
                <p>{paciente.objetivos}</p>
                <button
                  type="button"
                  className="pv-btn-small"
                  onClick={() => setEditObjetivos(true)}
                >
                  ✏️ Editar
                </button>
              </>
            )}
          </div>

          <div className="pv-section" style={{ marginTop: "2rem" }}>
            <h3>📅 Citas programadas (por realizar)</h3>
            <CitasFuturasTable
              citas={citasFuturas}
              isAdmin={isAdmin}
              dateFilter={dateFilterCitas}
              setDateFilter={setDateFilterCitas}
              handleDeleteCita={handleDeleteCita}
              formatDateLabel={formatDateLabel}
              formatTimeLabel={formatTimeLabel}
            />
          </div>

          <div className="pv-section" style={{ marginTop: "2rem" }}>
            <h3>✅ Citas realizadas</h3>
            <CitasPasadasTable
              citas={citasPasadas}
              dateFilter={dateFilterPasadas}
              setDateFilter={setDateFilterPasadas}
              selectedSesion={selectedSesion}
              toggleSesionDetalle={toggleSesionDetalle}
              nuevoComentario={nuevoComentario}
              setNuevoComentario={setNuevoComentario}
              handleAgregarComentario={handleAgregarComentario}
              formatDateLabel={formatDateLabel}
              formatTimeLabel={formatTimeLabel}
            />
          </div>

          {isAdmin && paciente.id && (
            <div className="pv-section" style={{ marginTop: "2rem" }}>
              <h3>💰 Historial de pagos</h3>
              <PagosTable
                pagos={pagos}
                paciente={paciente}
                dateFilter={dateFilterPagos}
                setDateFilter={setDateFilterPagos}
                formatDateLabel={formatDateLabel}
              />
            </div>
          )}

          <div style={{ marginTop: "2rem" }}>
            <CommentsThread patientId={paciente.id} />
          </div>
        </>
      )}

      {tab === "contrato" && <ContratoTab paciente={paciente} />}
      {tab === "consentimiento" && <ConsentimientoTab paciente={paciente} />}
      {tab === "otros" && <UploadTab patientId={paciente.id} type="otros" />}
    </div>
  );
}
